import type { Draft } from 'immer';
import produce from 'immer';

type mutableChanger<S, A> = (state: S, action: A) => void;
type reducer<S, A> = (state: S, action: A) => S;

export default function immerReducer<S, A>(changer: mutableChanger<Draft<S>, A>): reducer<S, A> {
    return produce(changer) as any;
}
